var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSetting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.281,
    height: 15.137,
    viewBox: "0 0 14.281 15.137",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "setting",
    transform: "translate(-0.082 -0.178)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    "data-name": "Path 54",
    d: "M13.487,4.654l-.451-.783a1.387,1.387,0,0,0-1.891-.511h0a1.38,1.38,0,0,1-1.891-.491A1.328,1.328,0,0,1,9.067,2.2h0A1.387,1.387,0,0,0,7.68.778H6.771a1.38,1.38,0,0,0-1.38,1.387h0A1.387,1.387,0,0,1,4,3.532a1.327,1.327,0,0,1-.664-.186h0a1.387,1.387,0,0,0-1.891.511l-.484.8a1.387,1.387,0,0,0,.5,1.891h0a1.387,1.387,0,0,1,0,2.4h0a1.38,1.38,0,0,0-.5,1.885h0l.458.79a1.387,1.387,0,0,0,1.891.538h0a1.374,1.374,0,0,1,1.885.5,1.327,1.327,0,0,1,.186.664h0a1.387,1.387,0,0,0,1.387,1.387H7.68a1.387,1.387,0,0,0,1.387-1.38h0a1.38,1.38,0,0,1,1.387-1.387,1.413,1.413,0,0,1,.664.186h0a1.387,1.387,0,0,0,1.891-.5h0l.478-.8a1.38,1.38,0,0,0-.5-1.891h0a1.38,1.38,0,0,1-.5-1.891,1.361,1.361,0,0,1,.5-.5h0a1.387,1.387,0,0,0,.5-1.885h0Z",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#3b57a9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_11",
    "data-name": "Ellipse 11",
    cx: 1.911,
    cy: 1.911,
    r: 1.911,
    transform: "translate(5.318 5.835)",
    fill: "none",
    stroke: "#3b57a9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetting);
export default __webpack_public_path__ + "static/media/setting.b5786340decf22e4fafe936f1e545139.svg";
export { ForwardRef as ReactComponent };